let host = window.location.host;
let appId=''
if (host === 'web.islide.cc') {
  appId = '2020687113';
} else {
  appId = '2075154305';
}
export default appId
